import { SchemaDeSerBuilder, type SchemaDeSer } from "./deser"

/**
 * Single Kalshi event from `GET /instruments/event-products/{exchange}/{code}/events`.
 * Used to source the human-readable event title (e.g. "Will CPI be above 2.4%?")
 * that the contract-chain endpoint omits.
 */
export class KalshiEventItem {
  externalId = ""
  title = ""
  stopsTradingAt = ""
}

export const KALSHI_EVENT_ITEM_DESER: SchemaDeSer<KalshiEventItem> =
  new SchemaDeSerBuilder(KalshiEventItem)
    .ofString("externalId", "external-id")
    .ofString("title")
    .ofString("stopsTradingAt", "stops-trading-at")
    .toDeSer()
